import now from './now.js';

export default {
  now
};



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/date.default.js
// module id = 1281
// module chunks = 0